export default {
  setCurrentDate(state, currentDate) {
    state.currentDate = currentDate;
  },
};



// WEBPACK FOOTER //
// ./src/stores/date/mutations.js